import { render, staticRenderFns } from "./RGroupedTabs.vue?vue&type=template&id=70a3bd24&scoped=true&"
import script from "./RGroupedTabs.vue?vue&type=script&lang=js&"
export * from "./RGroupedTabs.vue?vue&type=script&lang=js&"
import style0 from "./RGroupedTabs.vue?vue&type=style&index=0&id=70a3bd24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a3bd24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VIcon,VTab,VTabs})
